<div class="pr-3 pl-4 h-full w-full flex flex-col overflow-auto" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">1.3. Tỉ lệ số lượng người khuyết tật theo mức độ khuyết tật</span>
      <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
    </div>
    <div class="btn-option flex">
      <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
        <button nz-button class="flex items-center justify-center" nzTooltipTitle="Xuất excel"
          nzTooltipPlacement="bottom" nz-tooltip (click)="exportExcel()">
          <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
        <button nz-button class="flex items-center justify-center" (click)="exportExcel()">
          Xuất excel
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
        <button nz-button class="flex items-center justify-center" (click)="exportExcel()">
          <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
          Xuất excel
        </button>
      </ng-container>
    </div>
  </div>
  <form nz-form class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">

      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Tỉnh thành</nz-form-label>
          <asc-autocomplete  [disabled]="isDisabled || isDisabled1 || isDisabled2"  [ascModel]="DisProvincesControl" (ascModelChange)="changeDisProvincesACFn($event)"
            placeholder="Chọn tỉnh thành..." [getListAC]="getDisProvincesACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Quận huyện</nz-form-label>
          <asc-autocomplete [disabled]="isDisabled || isDisabled2" [ascModel]="DistrictControl" (ascModelChange)="changeDistrictACFn($event)"
            placeholder="Chọn quận huyện..." [getListAC]="getDistrictACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Phường/xã</nz-form-label>
          <asc-autocomplete [ascModel]="WardControl" (ascModelChange)="changeWardACFn($event)"
            placeholder="Chọn phường/xã..." [getListAC]="getWardACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <!-- <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Dạng tật</nz-form-label>
          <asc-autocomplete [ascModel]="TypeOfDisabilityControl" (ascModelChange)="changeTypeOfDisability($event)"
            [placeholder]="'Chọn dạng...'" [getListAC]="getTypeOfDisabilityACFn"></asc-autocomplete>
        </nz-form-item>
      </div> -->
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Mức độ khuyết tật</nz-form-label>
          <asc-autocomplete [ascModel]="LevelControl" (ascModelChange)="changeLevel($event)"
            [placeholder]="'Chọn mức độ khuyết tật...'" [getListAC]="getLevelACFn"></asc-autocomplete>
        </nz-form-item>
      </div>

      <ng-container *ngIf="!isCollapse">

      </ng-container>
      <div nz-col *ngIf="isCollapse" nzSpan="24">
        <div style="visibility: hidden; margin-top: 5px">i</div>
      </div>
    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
          nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="reload()">Tìm
            kiếm</button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'"
            nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="reload()"><i nz-icon
              nzType="search" nzTheme="outline"></i></button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="reload()"><i nz-icon
              nzType="search" nzTheme="outline"></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table #Table nzShowSizeChanger [nzLoading]="loading" [nzData]="dataTable" nzSize="small"
      [nzFrontPagination]="false" class="w-full absolute" [nzScroll]="{  y: height + 'px'}">
      <thead>
        <tr #pageHeaderTable>
          <th rowspan="2" nzWidth="50px" nzLeft>STT </th>
          <th rowspan="2" nzWidth="200px" nzLeft>Địa phương</th>
          <ng-container *ngFor="let item of dataHeader1">
            <th colspan="2" class="text-center" nzWidth="100px"> {{ item.dataName }} </th>
          </ng-container>
          <th colspan="2" class="text-center" nzWidth="100px">Tổng</th>
        </tr>
        <tr #pageHeaderTable2>
          <ng-container *ngFor="let item of dataHeader2">
            <th class="text-center" nzWidth="50px"> {{ item.dataName }}
            </th>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let data of Table.data; let i = index">
          <tr *ngIf="data.DpPtaId == true; else other_content" class="clsPta">
            <td nzLeft>{{ i + 1 }}</td>
            <td nzLeft>{{data.DpName}}</td>
            <ng-container *ngFor="let key of keyIdArr">
              <td class="text-center">{{data[key]}}</td>
              <td class="text-center ">{{(data[key]/data.DpTotal*100).toFixed(2)}} (%)</td>
            </ng-container>
            <td class="text-center">{{data.DpTotal}}</td>
            <td class="text-center ">100 (%)</td>
          </tr>
          <ng-template #other_content>
            <tr>
              <td nzLeft>{{ i + 1 }}</td>
              <td nzLeft><i nz-icon nzType="line" nzTheme="outline"></i> {{data.DpName}}</td>
              <ng-container *ngFor="let key of keyIdArr">
                <td class="text-center">{{data[key]}}</td>
                <td class="text-center ">{{(data[key]/data.DpTotal*100).toFixed(2)}} (%)</td>
              </ng-container>
              <td class="text-center">{{data.DpTotal}}</td>
              <td class="text-center ">100 (%)</td>
            </tr>
          </ng-template>
        </ng-container>
      </tbody>
    </nz-table>
  </div>
</div>
